import { render, staticRenderFns } from "./MRO_0031.vue?vue&type=template&id=a3a73980&scoped=true"
import script from "./MRO_0031.vue?vue&type=script&lang=ts"
export * from "./MRO_0031.vue?vue&type=script&lang=ts"
import style0 from "./MRO_0031.vue?vue&type=style&index=0&id=a3a73980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a73980",
  null
  
)

export default component.exports